"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.david.description': 'Tono profundo y relajante con bondad y sinceridad.',
};
